import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  DashboardStyles,
  DashboardButtonsContainer,
} from "../styles/DashboardStyles";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomButton from "../../../components/CustomButton/CustomButton";
import TittleLine from "../../../components/Common/TittleLine";
import CustomSeparator from "../../../components/Common/CustomSeparator";

const DashboardScreen = (props) => {
  const history = useHistory();

  const goTo = (screen) => {
    history.push(screen);
  };

  return (
    <CustomLayout>
      <CustomSeparator height={"20px"} />

      <Section>
        <TittleLine title={"Estás seguro que deseas cerrar sesión?"} weight={"bold"} />
      </Section>

      <Section>
        <DashboardButtonsContainer>
          <CustomButton
            label={"Si"}
            isLoading={false}
            width={DashboardStyles.homeButtonWidth}
            weight={"bold"}
            onClick={() => {
              goTo("/logout");
            }}
          />
          <CustomSeparator width={"10px"} />
          <CustomButton
            label={"No"}
            isLoading={false}
            width={DashboardStyles.homeButtonWidth}
            weight={"bold"}
            onClick={() => {
              goTo("/dashboard");
            }}
          />
        </DashboardButtonsContainer>
      </Section>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,
});

const mapDispatchToProps = {

};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(DashboardScreen);